import styled from 'styled-components';
import {
  BREAKPOINTS,
  BREAKPOINTS_NUM,
} from 'constants/Global/Breakpoints.const';

export const Container = styled.div`
  background-color: #fff9eb;
  padding: 12px 16px;
`;

export const Content = styled.div`
  margin: 0 auto;
  width: 100%;
`;

export const VerticalDivider = styled.div<{ showOnMobile?: boolean }>`
  width: 1px;
  height: 24px;
  background-color: #ffc370;
  margin: 0 8px;

  ${(props) =>
    props.showOnMobile
      ? `
    display: block;
    
    @media (min-width: ${BREAKPOINTS.tabletMini}) {
      display: none;
    }
  `
      : `
    display: none;
    
    @media (min-width: ${BREAKPOINTS.tabletMini}) {
      display: block;
    }
  `}
`;

export const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ffc370;
  margin: 12px 0;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: none;
  }
`;

export const DesktopLayout = styled.div`
  display: none;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-start;
  }
`;

export const MobileLayout = styled.div`
  display: block;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: none;
  }
`;

export const MobileHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const MobileExpandedContent = styled.div<{ isExpanded: boolean }>`
  display: ${(props) => (props.isExpanded ? 'block' : 'none')};
`;

export const MobileRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #853700;
  white-space: nowrap;
`;

export const CustomerButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  @media (max-width: ${BREAKPOINTS_NUM.tabletMini - 1}px) {
    max-width: 183px;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const CustomerText = styled.span`
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (min-width: ${BREAKPOINTS.tablet}) {
    max-width: 300px;
  }
`;

export const AmountContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ExpandButton = styled.button`
  display: none;
  text-wrap: auto;
  text-align: start;

  @media (max-width: ${BREAKPOINTS.tabletMini}) {
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    color: #853700;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
`;

export const MobileToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: #f78e1e;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: none;
  }
`;

export const SearchInputWrapper = styled.div`
  padding: 8px;

  .ant-input-affix-wrapper {
    &:hover,
    &:focus,
    &:focus-within {
      border-color: #f78e1e;
      box-shadow: 0 0 0 2px rgba(247, 142, 30, 0.1);
    }
  }
`;
